import React from 'react';
import { useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import s from './Input.module.css';
import { toast } from 'react-toastify';

export default function Input({ width = '100%', onSubmit }) {
  const [query, setQuery] = useState('');
  // const[active, setActive]=useState(true)

  const handleChange = event => {
    setQuery(event.currentTarget.value);
    // setActive(false)
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (query.trim() === '') {
      toast.error('Enter your query');
      return;
    }
    onSubmit(query);
    setQuery('');
  };
  return (
    <>
      <form
        onSubmit={handleSubmit}
        className={s.formField}
        style={{ width: `${width}` }}
      >
        <input
          id="id"
          type="text"
          name="search"
          className={s.formInput}
          value={query}
          onChange={handleChange}
        />
        <AiOutlineSearch className={s.searchIcon} />

        <button type="submit" className={s.searchButton}>
          Пошук
        </button>
      </form>
    </>
  );
}
